/* @flow */
import {combineReducers} from 'redux';
import type {Dispatch} from 'redux';

import ui from './modules/ui';

export default combineReducers ({
  ui,
});

export type Thunk<A> =  (dispatch: Dispatch<A>, getState: () => Object) => any;



// WEBPACK FOOTER //
// ./src/data/index.js